import React, { PropTypes, Component } from 'react';
import * as Icons from 'components/Material/SvgIcons';
import { ToolbarGroup, ToolbarButton } from 'components/Toolbar';
import debounce from 'oxygen-debounce';
import { Units, Colors } from 'Css';

const css = oxygenCss({
  wrapper: {
    position: 'relative',
    height: 40,
    width: '100%'
  },
  inputContainer: {
    backgroundColor: Colors.fullWhite,
    position: 'absolute',
    right: 48,
    left: 0,
    top: 0,
    bottom: 0
  },
  input: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
    padding: `0 ${Units.base}px`,
    verticalAlign: 'top',
    lineHeight: '44',
    height: 40,
    textAlign: 'left',
    boxSizing: 'border-box'
  },
  button: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0
  }
});

export default class SearchBar extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func
  };

  static defaultProps = {
    placeholder: 'Search'
  };

  componentWillUnmount() {
    this.changeSearchText.clear();
  }

  changeSearchText = debounce(value => {
    const { onChange } = this.props;
    onChange && onChange(value);
  }, 250);

  searchTextChange = event => {
    const { value } = event.target;
    this.changeSearchText(value.trim() || '');
  };

  render() {
    const { placeholder, onChange, ...other } = this.props;
    return (
      <ToolbarGroup {...other}>
        <div className={css.wrapper}>
          <div className={css.inputContainer}>
            <input
              className={css.input}
              type="text"
              placeholder={placeholder}
              onChange={this.searchTextChange}
            />
          </div>
          <ToolbarButton className={css.button}>
            <Icons.ActionSearch
              color={Colors.lightBlack}
              hoverColor={Colors.lightWhite}
            />
          </ToolbarButton>
        </div>
      </ToolbarGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/MediaLibrary/SearchBar.js